import type { ReactNode } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@shared/ui/src/components/overlay/dialog';
import { useDataManagementContext } from '../../../hooks/useDataManagementContext';

interface DataManagementDialogProps {
  children: ReactNode;
}

export function DataManagementDialog({ children }: DataManagementDialogProps) {
  const { isOpen, onOpenChange, title, selectedItem } = useDataManagementContext();

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {selectedItem ? `Edit ${title.slice(0, -1)}` : `Create ${title.slice(0, -1)}`}
          </DialogTitle>
          <p className="text-sm text-muted-foreground">
            {selectedItem 
              ? `Update the ${title.toLowerCase()} details below.`
              : `Enter the ${title.toLowerCase()} details below.`}
          </p>
        </DialogHeader>
        {children}
      </DialogContent>
    </Dialog>
  );
} 